import React, { FC } from "react";
import { useSelector } from "react-redux";
import { Col, Row } from 'react-styled-flexboxgrid';
import { configSelector } from '../../../../redux/selectors/system/config-selector';
import GLField from '../../../../components/form/gl-field';
import FormInput, { FormInputProps } from '../../../../components/form-input/form-input';
import { FieldConfig, Config, StateFieldConfig, AvailableFromConfig } from '../../../../types/config/config';
import FormDateField, { FormDateFieldProps } from "../../../../components/form-date-field/form-date-field";
import FormCheckbox, { FormCheckboxProps } from "../../../../components/form-checkbox/form-checkbox";
import styled from "styled-components";
import SectionHeading from "../../../../components/section-heading/section-heading";

interface Props {
    manualError: Object,
    changeHandler(values: any): void
}

export const SoldInfo: FC<Props> = (props) => {

    const { manualError } = props;

    const config = useSelector(configSelector);
    const soldInfoConfig = config.soldInfo;

    if (!soldInfoConfig || !soldInfoConfig.show) {
        return null;
    }

    const getSoldPrice = () => {
        if (soldInfoConfig.soldPrice && soldInfoConfig.soldPrice.show) {
            return (
                <Col xs={12} sm={4} md={4} lg={4}>
                    <GLField<FormInputProps>
                        name="soldInfo.soldPrice"
                        placeholder={soldInfoConfig.soldPrice.label}
                        label={soldInfoConfig.soldPrice.label}
                        use={FormInput}
                        numericOnly={true} acceptDecimals={true}
                        error={true}
                        maxLength={300} />
                </Col>
            );
        }
        return null;
    }

    const getSoldDate = () => {
        if (soldInfoConfig.soldDate && soldInfoConfig.soldDate.show) {
            const fieldConfig: AvailableFromConfig = config.soldInfo.soldDate;
            return (
                <Col xs={12} sm={4} md={4} lg={4}>
                    <GLField<FormDateFieldProps>
                        name="soldInfo.soldDate"
                        placeholder={soldInfoConfig.soldDate.label}
                        label={soldInfoConfig.soldDate.label}
                        error={true}
                        use={FormDateField}
                        {...fieldConfig} />
                </Col>
            );
        }
        return null;
    }

    const getDisplayPrice = () => {
        if (soldInfoConfig.displayPrice && soldInfoConfig.displayPrice.show) {
            return (
                <Col xs={12} sm={4} md={4} lg={4}>
                    <DisplayPriceContainer>
                        <GLField<FormCheckboxProps>
                            use={FormCheckbox}
                            error={true}
                            name="soldInfo.displayPrice"
                            label={soldInfoConfig.displayPrice.label}
                        />
                    </DisplayPriceContainer>
                </Col>
            );
        }
        return null;
    }

    const DisplayError = () => {
        let errorMessages = manualError.soldInfo.message;
        if (!errorMessages || errorMessages.length === 0) {
            return null;
        }
        else {
            errorMessages = Array.isArray(errorMessages) ? errorMessages : [errorMessages];
        }
        return (
            <Row>
                {
                    errorMessages.map((error: string, index: number) => (
                        <Col key={index} sm={12}>
                            <ErrorText>{error}</ErrorText>
                        </Col>
                    ))
                }
            </Row>
        )
    }

    return (<>
        <Row>
            <Col id="sizes" xs={12}><SectionHeading error={manualError && manualError.soldInfo && manualError.soldInfo.error}>{soldInfoConfig.header}</SectionHeading></Col>
        </Row>
        {manualError && manualError.soldInfo && manualError.soldInfo.error && <DisplayError />}
        <Row>
            {getSoldPrice()}
            {getSoldDate()}
            {getDisplayPrice()}
        </Row>
    </>);
};

const DisplayPriceContainer = styled.div`
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;
    height: 100%;
`


const ErrorText = styled.div`
    color: ${props => (props.theme.colors ? props.theme.colors.error : 'red')}; 
`;

const StyledSubtext = styled.div`
  color: #9EA8AB;
  margin-block-start: -1em;
  font-family: "futura PT Book italic";
  font-size: 14px;
  margin-left: 0.5em;
`;